module.exports = __webpack_public_path__ + "img/Symbol_Translate.2e4d48cc.svg";